import { getIsFeatureToggleEnabled } from 'communicator/store/selectors';
import { B2CIAMErrorResponse } from 'types/api/b2ciam';
import {
  IdLookupResponse,
  OrchestratorIdLookupRequest,
  OrchestratorIdLookupResponse
} from 'types/api/id-lookup';
import { IdentityType } from 'types/emvco';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';
import getVbaToken from '../get-vba-token';

type FetchIdLookupOptions = {
  apikey: string;
  email: string;
  sessionId: string;
  thmProfileHint: string | null;
  usernameType?: string;
};

export default async function fetchIdLookup({
  apikey,
  email,
  sessionId,
  thmProfileHint,
  usernameType = 'EMAIL'
}: FetchIdLookupOptions): FetchResponse<IdLookupResponse, B2CIAMErrorResponse> {
  const headers: Record<string, string> = {
    Authorization: `Basic ${window.btoa(apikey)}`
  };

  let uebaSource = 'THREAT_METRIX';
  let uebaId: string | null = sessionId;

  if (getIsFeatureToggleEnabled('vbaDeviceProfile')) {
    uebaId = await getVbaToken(); // TODO: after POC, this needs to be populated from the VBA token at fetch() calltime
    uebaSource = 'VBA';
  }

  if (thmProfileHint) {
    headers['x-via-hint'] = thmProfileHint;
  }

  return fetchReq({
    body: {
      function: 'LOGIN@IDL',
      grant_type: 'idproof_promise',
      promises: [
        {
          data: email,
          data_kind: usernameType,
          ref: 1
        }
      ],
      response_type: ['token', 'id_token'],
      software_statement_claimset: {
        oauth2_version: '1.0',
        oidc_version: '1.0',
        software_id: 'SRC',
        software_version: '21.03',
        tenancy_context: {
          product_code: 'VXO'
        },
        uebas: [
          {
            ueba_id: uebaId,
            ueba_source: uebaSource
          }
        ]
      }
    },
    headers,
    mark: 'id_lookup',
    method: 'POST',
    url: endpoints.token.idLookup
  });
}

/* START GENAI@GHCOPILOT */
type OrchestratorIdLookupOptions = {
  apikey: string;
  identityType: IdentityType;
  identityValue: string;
  thmProfileHint: string | null;
  isVdiDisabled: boolean;
};

export function fetchOrchestratorIdLookup({
  apikey,
  identityType,
  identityValue,
  thmProfileHint,
  isVdiDisabled
}: OrchestratorIdLookupOptions): FetchResponse<OrchestratorIdLookupResponse, B2CIAMErrorResponse> {
  const requestBody: OrchestratorIdLookupRequest = {
    srcClientId: apikey,
    consumerIdentity: {
      identityProvider: 'SRC',
      identityType,
      identityValue
    }
  };

  if (isVdiDisabled) {
    requestBody.isVdiDisabled = true;
  }

  return fetchReq({
    body: requestBody,
    headers: thmProfileHint
      ? {
          'x-via-hint': thmProfileHint
        }
      : undefined,
    mark: 'orchestrator_id_lookup',
    method: 'POST',
    url: endpoints.orchestrator.idLookup
  });
}
/* END GENAI@GHCOPILOT */
